function format_currency (number) {
  if (number == null) return
  if (number % 1 === 0) {
    return `$${number}`
  }
  // fixed a -0 issue in js
  if (Math.round(number, 2) === 0) {
    return '$0'
  }
  return `$${number.toFixed(2)}`
}

export {
  format_currency,
}
